export let LOCALE = "";
export let RELEASE = "";

import {FEEDSOURCE} from 'feedSource.js'; // Imports the feed type if one was specified as a webpack parameter

let pathname = window.location.pathname;
if (pathname === "/software.html" || pathname === "/software-long-term-support.html") {
  LOCALE = "en-us";
  RELEASE = "lts,tree_lts";
} else if (pathname === "/software-earlier-versions.html") {
  LOCALE = "en-us";
  RELEASE = "ev,tree_ev";
} else if (pathname === "/software-feature-releases.html") {
  LOCALE = "en-us";
  RELEASE = "fr,tree_fr";
} else if (pathname === "/ja-jp/software.html" || pathname === "/ja-jp/software-long-term-support.html") {
  LOCALE = "ja-jp";
  RELEASE = "lts,tree_lts";
} else if (pathname === "/ja-jp/software-earlier-versions.html") {
  LOCALE = "ja-jp";
  RELEASE = "ev,tree_ev";
}

export let RELEASES = RELEASE.split(",");

export function getFeedPath() {
  const environment = getParameterByName('environment');
  const domain = window.location.host;

  const prodPath = 'help-deepsecurity-trendmicro/Resources/CustomScripts/download-center/data/ds-dlc-feed-src';
  const stagingPath = 'help-deepsecurity-trendmicro/Resources/CustomScripts/download-center/data/ds-dlc-feed-src-staging';
  const devPath = 'help-deepsecurity-trendmicro/Resources/CustomScripts/download-center/data/ds-dlc-feed-src-dev';

  const prodDomain = 'help.deepsecurity.trendmicro.com';
  const stagingDomain = 'staging-helpcenter.deepsecurity.trendmicro.com';
  const devDomain = 'dev-helpcenter.deepsecurity.trendmicro.com';

  const prodID = 'production';
  const stagingID = 'staging';
  const devID = 'dev';
  const localPortRegex = /localhost:?\d{0,5}/g

  if (domain === prodDomain || environment === prodID) {
    return prodPath;
  } else if (domain === stagingDomain || environment === stagingID) {
    return stagingPath;
  } else if (domain === devDomain || environment === devID) {
    return devPath;
  } else if (localPortRegex.test(domain) === true) {
    if (FEEDSOURCE === 'prod') {
      return prodPath;
    } else if (FEEDSOURCE === 'staging') {
      return stagingPath;
    } else if (FEEDSOURCE === 'dev') {
      return devPath;
    }
  }

  return prodPath;
}

function getParameterByName(name) {
  let query = window.location.search;
  let value = '';

  query = query.replace('?', '');
  query = query.split('&');

  query.forEach(param => {
    param = param.split('=');
    if (param[0] === name) {
      value = param[1];
    }
  });

  return value;
}
